import { Link } from "react-router-dom";
import { Mail, FolderPlus } from "lucide-react";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const stop = (e) => e.stopPropagation();

function Action({ href, to, icon: Icon, label, disabledHint, testid }) {
  const cls = "inline-flex items-center justify-center h-8 w-8 rounded-lg transition-colors";
  if (disabledHint) return <span data-testid={`${testid}-disabled`} title={disabledHint} className={`${cls} text-slate-200 cursor-not-allowed`}><Icon className="h-4 w-4" /></span>;
  const active = `${cls} text-slate-400 hover:text-primary hover:bg-primary/10`;
  return to
    ? <Link to={to} onClick={stop} title={label} data-testid={testid} className={active}><Icon className="h-4 w-4" /></Link>
    : <a href={href} onClick={stop} title={label} data-testid={testid} className={active}><Icon className="h-4 w-4" /></a>;
}

export function ClientRowActions({ client, canCreateCase }) {
  return (
    <div className="inline-grid grid-flow-col auto-cols-[2rem] gap-1 items-center" data-testid={`client-actions-${client.id}`}>
      <WhatsAppButton target={{ kind: "client", id: client.id, name: client.full_name, phone: client.phone, file_number: client.file_number }} testid={`client-whatsapp-${client.id}`} />
      <Action href={`mailto:${client.email}`} icon={Mail} label={`Email ${client.email}`} disabledHint={client.email ? "" : "No email on file"} testid={`client-email-${client.id}`} />
      {canCreateCase && <Action to={`/admin/applications?new=1&client=${client.id}`} icon={FolderPlus} label="New case" testid={`client-new-case-${client.id}`} />}
    </div>
  );
}
